module.exports = __webpack_public_path__ + "static/media/Evolve.042c1f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Evolve.png
// module id = 91
// module chunks = 0